import React, { memo, useState } from 'react';
import { Stack } from 'investira.react.components';
import CenariosDetalhes from './CenariosDetalhes';
import DetalhesDialog from './DetalhesDialog';
const Cenarios = memo(props => {
  const { data } = props;
  const [ativos, setAtivos] = useState({});
  const [infos, setInfos] = useState({});
  const [correlacoes, setCorrelacoes] = useState({});
  const xBenchmarks = data.response?.detalhe?.benchmarks;
  return (
    <Stack spacing={4}>
      <CenariosDetalhes
        data={data}
        onSetAtivos={setAtivos}
        onSetInfos={setInfos}
        onSetCorrelacoes={setCorrelacoes}
      />
      <DetalhesDialog
        benchmarks={xBenchmarks}
        ativos={ativos}
        correlacoes={correlacoes}
        infos={infos}
        onSetAtivos={setAtivos}
      />
    </Stack>
  );
});
Cenarios.displayName = 'Cenarios';
export default Cenarios;
